import React from "react";
import ReactDOM from "react-dom/client";
import routes from "./routes/routesConfig";
import "./styles/global.css";
import "./styles/design-token.css";

import { RouterProvider } from "react-router-dom";
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <RouterProvider router={routes} />
  </React.StrictMode>,
);
